import React from "react";
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

class InstallationsHourlyGraph extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <ResponsiveContainer width={'100%'} height={300}>
                    <LineChart
                        width={500}
                        height={300}
                        data={this.props.data || []}
                        margin={{
                            top: 5, right: 30, left: 20, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="hour" />
                        <YAxis yAxisId="left" />
                        <YAxis yAxisId="right" orientation="right"/>
                        <Tooltip/>
                        <Legend/>
                        <Line yAxisId="left" type="linear" dataKey="payouts" stroke="#ff0000" dot={{ stroke: '#ff0000', strokeWidth: 3 }} activeDot={{ stroke: '#ff0000', strokeWidth: 3 }} strokeWidth={3}/>
                        <Line yAxisId="left" type="linear" dataKey="roi" stroke="#008000" dot={{ stroke: '#008000', strokeWidth: 3 }} activeDot={{ stroke: '#008000', strokeWidth: 3 }} strokeWidth={3} />
                        <Line yAxisId="right" type="linear" dataKey="percentRoi" stroke="#5c00e6" dot={{ stroke: '#5c00e6', strokeWidth: 3 }} activeDot={{ stroke: '#5c00e6', strokeWidth: 3 }} strokeWidth={3} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        )
    }
}

export default InstallationsHourlyGraph;


// WEBPACK FOOTER //
// ./src/scenes/ApkInstallationsHourly/components/InstallationsHourlyGraph/index.js